/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdvancedSearchPromptOrigin = {
    SuggestedPrompt: 'SUGGESTED_PROMPT',
    CatalogPrompt: 'CATALOG_PROMPT',
    UserPrompt: 'USER_PROMPT',
    UserPromptHomepageUnlogged: 'USER_PROMPT_HOMEPAGE_UNLOGGED',
    UserPromptNavbarUnlogged: 'USER_PROMPT_NAVBAR_UNLOGGED'
} as const;
export type AdvancedSearchPromptOrigin = typeof AdvancedSearchPromptOrigin[keyof typeof AdvancedSearchPromptOrigin];


export function instanceOfAdvancedSearchPromptOrigin(value: any): boolean {
    for (const key in AdvancedSearchPromptOrigin) {
        if (Object.prototype.hasOwnProperty.call(AdvancedSearchPromptOrigin, key)) {
            // @ts-ignore
            if (AdvancedSearchPromptOrigin[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdvancedSearchPromptOriginFromJSON(json: any): AdvancedSearchPromptOrigin {
    return AdvancedSearchPromptOriginFromJSONTyped(json, false);
}

export function AdvancedSearchPromptOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchPromptOrigin {
    return json as AdvancedSearchPromptOrigin;
}

export function AdvancedSearchPromptOriginToJSON(value?: AdvancedSearchPromptOrigin | null): any {
    return value as any;
}

